import { render } from "./MoveItems.vue?vue&type=template&id=6f27dfb8"
import script from "./MoveItems.vue?vue&type=script&lang=js"
export * from "./MoveItems.vue?vue&type=script&lang=js"

import exportComponent from "/Users/tasselchof/CodeProjects/oarus/oarus-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../../../../../oarus-app/node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QBadge,QIcon});
